export const ExcelFileType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export default ExcelFileType;

export function getFileName(file?: string | File) {
  if (!file) return '';

  if (typeof file === 'string') {
    const { pathname } = new URL(file, window.location.origin);

    const match = pathname.match(/([^\\/.]+)\..+$|([^\\/.]+)$/);
    if (!match) return '';

    return match[1] || match[2];
  }

  if ('name' in file) return file.name;

  return '';
}

export function fileSizeToMb<File extends { size: number }>(file?: File) {
  if (file && typeof file === 'object' && 'size' in file) {
    return file.size / 1_048_576;
  }

  return 0;
}

export function fileSizeToKiB<File extends { size: number }>(file?: File) {
  if (file && typeof file === 'object' && 'size' in file) {
    return file.size / 1_024;
  }

  return 0;
}

const MIME_SIGNATURES: [string, number[]][] = [
  ['image/jpeg', [0xff, 0xd8, 0xff]],
  ['image/png', [0x89, 0x50, 0x4e, 0x47]],
  ['application/pdf', [0x25, 0x50, 0x44, 0x46]],
  ['video/mp4', [0x00, 0x00, 0x00]],
];

export async function detectMimeType(file: File): Promise<string | undefined> {
  try {
    const bytes = new Uint8Array(await file.slice(0, 4).arrayBuffer());
    return MIME_SIGNATURES.find(([, sig]) =>
      sig.every((b, i) => bytes[i] === b)
    )?.[0];
  } catch {
    return undefined;
  }
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
